import { OUTPUT_TTL } from '../../../constants/Pac';
import type { IBatchStore } from '../batch-store-types';
import type { IMixer } from '../../../../types/device/DeviceModels';

const MIXER_ON_OFF_TIME = '2000';

/**
 * Mixer On/Off
 *
 * @param batchStore
 * @param mixer
 * @param {boolean} turnOn
 */
export const mixerSwitch = (
  batchStore: IBatchStore,
  mixer: IMixer,
  turnOn: boolean = true,
): void => {

  if (!mixer?.mixerOnPNo) {
    return;
  }

  const mixerStatus = batchStore.getDeviceStatus(mixer.id);

  batchStore.deviceStatus.set(mixer.id, {
    ...mixerStatus,
    active: turnOn,
  });

  if (mixer.mixerOffPNo) {
    if (turnOn) {
      batchStore.setOutput(mixer.mixerOnPNo, MIXER_ON_OFF_TIME);
    } else {
      batchStore.setOutput(mixer.mixerOffPNo, MIXER_ON_OFF_TIME);
    }
  } else {
    batchStore.setOutput(mixer.mixerOnPNo, turnOn ? OUTPUT_TTL : '0');
  }

};
